import { useState } from 'react';

export const useWizardStep = () => {
  const [showNext, setShowNext] = useState<boolean>(false);
  const [showPrevious, setShowPrevious] = useState<boolean>(false);

  const advance = () => {
    setShowNext(true);
    setShowPrevious(false);
  };

  const goBack = () => {
    setShowPrevious(true);
    setShowNext(false);
  };

  return { showNext, showPrevious, advance, goBack };
};
